import { nthArg } from 'lodash';
import { createAction } from '@wix/communities-blog-client-common';

export const REFRESH_POSTS = 'posts/REFRESH';

export const refreshPosts = createAction(REFRESH_POSTS, nthArg(0), nthArg(1));
